import { useEffect, useState } from 'react';
import { parseQuery } from 'url-lib';

// This allows us to lazyload images by adding the "lazyload" CSS class to an <img>, <div>, or other HTML elements.
// See their docs for usage info: https://github.com/aFarkas/lazysizes

export const handleLazy = (e: any) => {
    const bg = e?.target?.getAttribute('data-bg');
    if (bg) {
        e.target.style.backgroundImage = 'url(' + bg + ')';
    }
};

const initializeLazySizes = () =>
    document.addEventListener('lazybeforeunveil', handleLazy, false);

const unmountLazySizes = () => {
    document.removeEventListener('lazybeforeunveil', handleLazy, false);
};

//conditions in which we don't want to load the lazyimages lib
const shouldImportLib = () => {
    //There are issues with clicks coming from the facebook crawler
    //We are unable to determine the IP address from the client to
    //catch facebook requests, however we can include urls with
    //the `fbclid` query param.
    //https://github.com/aFarkas/lazysizes/issues/520
    const parsedQuery = parseQuery(window.location.search);
    if (Object.keys(parsedQuery).includes('fbclid')) {
        return false;
    }

    return true;
};

export const useLazyImages = (isLazyImage = false) => {
    const [shouldUseLazyImages, setShouldUseLazyImages] = useState(true);
    const [libLoaded, setLibLoaded] = useState(false);

    useEffect(() => {
        if (isLazyImage && shouldImportLib() && !libLoaded) {
            // This will trigger an import per hook use, but the
            // package will be cached by browser resulting in only
            // one total request.
            import('lazysizes').then(
                () => {
                    setLibLoaded(true);
                },
                () => {
                    setShouldUseLazyImages(false);
                },
            );
        } else if (!shouldImportLib()) {
            setShouldUseLazyImages(false);
        }
    }, [isLazyImage, libLoaded]);

    useEffect(() => {
        if (isLazyImage && libLoaded) {
            initializeLazySizes();
        }

        return () => {
            if (isLazyImage && libLoaded) {
                unmountLazySizes();
            }
        };
    }, [isLazyImage, libLoaded]);

    return { shouldUseLazyImages };
};
